import { FunctionComponent, useState } from "react";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ReactComponent as ChevronDown } from "@assets/icons/inbox/chevron-down.svg";

import { SvgIcon } from "@/components/Icon/SvgIcon";
import { classNames } from "@/utils/classNames";

import { REENGAGE_FIELDS } from "../constants/reengage.constants";
import { ReengageSourceFormValues } from "../schema/reengageSource";
import { ReengageDropdownField } from "./ReengageDropdownField";

interface AdvancedFiltersSectionProps {
	control: Control<ReengageSourceFormValues>;
	listId?: number;
}

export const AdvancedFiltersSection: FunctionComponent<AdvancedFiltersSectionProps> = ({
	control,
	listId,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`list.reengage.${key}`);
	const [open, setOpen] = useState(false);

	return (
		<div className="mt-2 border-t border-dashed border-border pt-4">
			<button
				className="flex items-center gap-1.5 text-[13px] font-medium text-text-meta hover:text-text"
				type="button"
				onClick={() => setOpen((prev) => !prev)}
			>
				<SvgIcon
					className={classNames("w-4 h-4 transition-transform", open ? "rotate-0" : "-rotate-90")}
					svgIcon={ChevronDown}
				/>
				<span>{ts("advancedFilters")}</span>
				<span className="text-text-disabled font-normal">· {ts("locations")}</span>
			</button>

			{open && (
				<div className="mt-4">
					<ReengageDropdownField
						control={control}
						label={ts("companyHqLocation")}
						listId={listId}
						name="companyHqLocation"
						placeholder={ts("allLocations")}
						propertyName={REENGAGE_FIELDS.companyHqLocation.name}
					/>
					<ReengageDropdownField
						control={control}
						label={ts("personalLocation")}
						listId={listId}
						name="personalLocation"
						placeholder={ts("allLocations")}
						propertyName={REENGAGE_FIELDS.personalLocation.name}
					/>
				</div>
			)}
		</div>
	);
};
